export const FEATURE_ICON_CLASS = 'text-indigo-base'
